import { FC, memo, ReactNode } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import Icon from 'builder/components/Icon'
import { MobileSlideModal } from 'builder/components/MobileSlideModal'

import {
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalTitle,
  ModalCaption,
  ModalCloseButton,
  ModalDoneButton,
} from './styles'

type Props = {
  isOpen?: boolean
  onClose?: () => void
  title?: string
  caption?: string
  children: ReactNode
  isScrollDisabled?: boolean
}

export const CardModal: FC<Props> = memo(props => {
  const { isOpen, title, caption, onClose, children, isScrollDisabled } = props
  const { i18n } = useI18n()

  return (
    <MobileSlideModal isOpen={isOpen} onClose={onClose} isScrollDisabled={isScrollDisabled}>
      <ModalContent>
        <ModalHeader>
          <ModalCloseButton onClick={onClose}>
            <Icon.Chevron />
          </ModalCloseButton>

          <ModalTitle>{title}</ModalTitle>
          <ModalCaption>{caption}</ModalCaption>
        </ModalHeader>

        {children}
      </ModalContent>

      <ModalFooter>
        <ModalDoneButton onClick={onClose}>{i18n.t('builder.resume_editor.done')}</ModalDoneButton>
      </ModalFooter>
    </MobileSlideModal>
  )
})
